// extracted by mini-css-extract-plugin
export default {"btn":"editButons_btn__iRGyf","svg":"editButons_svg__tYGqe"};